import React, { Component, Fragment } from 'react';
// redux
import { connect } from 'react-redux';
import { getUserSkills } from '../../redux/reducers/skills';
// utils
import get from 'lodash.get';
// components
import { Link } from 'react-router-dom';
import Icon from '../../components/Icon/Icon';
import SkillsListEdit from './components/SkillsListEdit';
import SkillsList from './components/SkillsList';
import SkillsPlaceholder from './components/SkillsPlaceholder';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Preloader from '../../components/Preloader/Preloader';
import Calendar from '../../components/Calendar/Calendar';
// styles
import Style from 'style-it';
import classnames from 'classnames/bind';
import styles from './Skills.mod.css';
import AddSkillButton from './components/AddSkillButton';

const cn = classnames.bind(styles);

class Skills extends Component {
  componentDidMount() {
    this.props.getUserSkills();
  }

  render() {
    const {
      userSkills,
      isLoading,
      match: { params },
      userColor
    } = this.props;
    const isEditMode = params.mode === 'edit';
    const noSkills = userSkills && userSkills.length === 0;
    const hasSkills = userSkills && userSkills.length > 0;

    return (
      <PageWrapper className={cn('wrapper')}>
        <Preloader className={cn('preloader')} custom isActive={isLoading} />
        <div className="row">
          <h2 className="centered">{isEditMode ? 'Edit Skills' : 'Skills'}</h2>
          {noSkills && <SkillsPlaceholder />}
          {hasSkills && (
            <Fragment>
              <div className={cn(styles.buttonsWrapper, 'col-sm-2 col-xs-12')}>
                <Style>
                  {`
                    .colored:hover { color: ${userColor}; }
                    .colored:hover i { background-color: ${userColor}; }
                  `}
                  <Link
                    to={isEditMode ? '/skills' : '/skills/edit'}
                    className={cn('link', 'colored')}
                  >
                    <Icon
                      type={isEditMode ? 'close' : 'edit'}
                      className={cn('button-icon')}
                    />
                    {isEditMode ? 'Close edit mode' : 'Edit skills'}
                  </Link>
                </Style>
                <AddSkillButton />
                {isEditMode && (
                  <p className={cn('hint')}>
                    You can change the order of your skills by simply dragging
                    them in order that you like.
                  </p>
                )}
              </div>
              <div className={cn('skills-container', 'col-sm-10 row')}>
                <div
                  className={cn('list-wrapper', 'col-md-8 col-sm-7 col-xs-12')}
                >
                  {isEditMode ? <SkillsListEdit /> : <SkillsList />}
                </div>

                <div className={cn('col-md-4 col-sm-5 col-xs-12')}>
                  <div className={cn('calendar-wrapper')}>
                    <Calendar events={userSkills} color={userColor} />
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </PageWrapper>
    );
  }
}

export default connect(
  state => ({
    userSkills: state.skills.userSkills,
    defaultSkills: state.skills.defaultSkills,
    isLoading: state.skills.isLoading,
    userColor: get(state.auth, 'user.profile_color') || '#33C370'
  }),
  { getUserSkills }
)(Skills);



// WEBPACK FOOTER //
// ./src/containers/Skills/Skills.jsx